module.exports = __webpack_public_path__ + "img/excel1.6bec7e63.png";